var React = require('react');

function PredominantSoundFilterIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#025A4D","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"1.5","d":"M10 21V1m2.647 1.818L10 5.545 7.353 2.818m0 17.273L10 17.364l2.647 2.727M18.382 6 1.618 16m.176-3.273 3.618 1-.97 3.727M19 8.819l-3.618-1 .97-3.727M1.619 6l16.764 10m-2.823 1.454-.97-3.727 3.617-1M3.647 4.091l.97 3.727-3.617 1"}));
}

PredominantSoundFilterIconInline.defaultProps = {"width":"20","height":"22","fill":"none","viewBox":"0 0 20 22"};

module.exports = PredominantSoundFilterIconInline;

PredominantSoundFilterIconInline.default = PredominantSoundFilterIconInline;
